import React from "react";
import { useTranslation } from "react-i18next";
import { LvlFilterBox } from "../../../components/layout/LvlFilterBox";
import { LvlPagiArea } from "../../../components/layout/LvlPagiArea";
import { CateSortBtn } from "../../../components/sort-btn/CateSortBtn";
import { CommonSortBtn } from "../../../components/sort-btn/CommonSortBtn";
import { useSearchProductPage } from "../../../hooks/useSearchProductPage";

const ListView: React.FC = () => {
  const type = "TOUR";
  const jj = useSearchProductPage({ type });
  const { t } = useTranslation();
  return (
    <div className="flex gap-[1.125rem]">
      <section className="flex-1">
        <LvlFilterBox
          text={jj.totalElements ? `${jj.totalElements} ${t("results")}` : ""}
        >
          <div className="flex gap-4">
            <CateSortBtn {...jj} />
            <CommonSortBtn {...jj} />
          </div>
        </LvlFilterBox>
        <LvlPagiArea {...jj} />
      </section>
    </div>
  );
};

export default ListView;
